import { forwardRef } from 'react';
import { cls } from '~/utils';

export const ScrollBar = forwardRef<HTMLDivElement, { isPaginationHidden: boolean }>(
  ({ isPaginationHidden }, ref) => {
    return (
      <div
        className={cls('GReportTable__ScrollBarContainer', {
          'GReportTable__ScrollBarContainer--pagination-hidden': isPaginationHidden,
        })}
        ref={ref}
      >
        <div className="GReportTable__ScrollBar">
          <div className="GReportTable__ScrollBarContent"></div>
        </div>
      </div>
    );
  },
);

ScrollBar.displayName = 'ScrollBar';
